import { Checkbox, Form } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { symptomsOptions } from "../../Options/psychologistOptions";
import { PsychologistInitialContext } from "../../Psychologist/InitialInspection/PsychologistInitialAssessmentProvider";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const Symptoms = ({ form }) => {
  const { formData } = useContext(PsychologistInitialContext);
  const [showOthers, setShowOthers] = useState(false);
  const handleChange = (values) => {
    setShowOthers(values?.includes("others"));
  };
  useEffect(() => {
    form.setFieldsValue(formData?.symptoms);
    setShowOthers(formData?.symptoms?.symptoms?.includes("others"));
  }, [formData]);
  return (
    <>
      <Form.Item name={"symptoms"}>
        <Checkbox.Group options={symptomsOptions} onChange={handleChange} />
      </Form.Item>
      {showOthers && (
        <>
          <DynamicInputFields
            field_key={"others"}
            form={form}
            inputStyle={{ maxWidth: 800 }}
          />
        </>
      )}
    </>
  );
};

export default Symptoms;
